<template>
  <UserForm :user="user" :userClaims="newClaims" :userCompanies="companies" :userDepartmentAccess="departmentAccess" :userDefaultDepartment="defaultDepartment"></UserForm>
</template>

<script>
import {mapGetters} from 'vuex';
import users from '@/mixins/users/users';
import UserForm from '../../../components/userManagement/userForm.vue';

export default {
  name: 'UsermanagementCreate',
  components: {UserForm},
  mixins: [users],
  data() {
    return {
      user: {
        email: null,
        emailVerified: false,
        displayName: null,
        disabled: false,
      },
      newClaims: {
        admin:false,
        teamlead:false,
        manager:false,
        root:false,
        validEmail: true
      },
      companies: [],
      departmentAccess: [],
      defaultDepartment: null
    };
  },
  firestore() {
    return {
      companies: this.$FB.collection('companies')
    };
  },
  methods: {
  },
  computed: {
    ...mapGetters('users', [
      'getMe'
    ]),
    ...mapGetters('company', [
      'getCompanyDepartments'
    ]),
    claims() {
      return this.$FirebaseAuth.getClaims();
    }
  },
  watch:{
    departmentAccess(newV,oldV){
    if(!oldV.length){
      this.defaultDepartment = newV[0]
    }
    }
  },
  created() {
    if (!this.claims.root) {
      this.newClaims.companyId = this.claims.companyId;
    }
  }
};
</script>

